<template>
  <section-page
    title="Unit Counts"
  >
    <template v-slot:right>
      <filter-field-default
        label="sort by"
        v-model="sortBy"
      >
        <option
          v-for="option in sortOptions"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}
        </option>
      </filter-field-default>

      <filter-button-add @click="openCreateUnitCountModal()">New Unit Count</filter-button-add>
    </template>

    <app-loading-section
      :loading="loading"
      :count="unitCounts.length"
      heading="There are no campaign unit counts"
    >
      <table-default :table-data="unitCountsFormatted">
        <b-table-column
          label="Name"
          field="label"
          v-slot="props"
        >{{ props.row.label }}</b-table-column>

        <b-table-column
          label="Date"
          field="date"
          width="100"
          v-slot="props"
        >{{ formatDate(props.row.date) }}</b-table-column>

        <b-table-column
          label="Unit Count"
          field="count"
          width="140"
          v-slot="props"
        >{{ props.row.count }}</b-table-column>

        <b-table-column
          label="Description"
          field="description"
          v-slot="props"
        ><div v-html="truncateDescription(props.row.description)"></div></b-table-column>

        <b-table-column
          cell-class="has-text-right"
          width="70"
          v-slot="props"
        >
          <button-link @click="openEditUnitCountModal(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>
    </app-loading-section>

    <modal-container>
      <modal-crud-form
        ref="campaignUnitCountModal"
        title="Campaign Unit Count"
        :collection.sync="unitCounts"
        form-component="campaign-unit-count-form"
      ></modal-crud-form>
    </modal-container>
  </section-page>
</template>

<script>
import {useCampaignStore} from "../campaigns.store";
import {onMounted, ref, computed} from "vue";
import utils from "../../../services/utils";
import dates from "../../../services/dates";

export default {
  name: "CampaignUnitCounts",
  setup() {
    const campaignStore = useCampaignStore();
    const loading = ref(true);

    onMounted(() => {
      campaignStore.loadUnitCounts().then(() => {
        loading.value = false;
      });
    });

    const unitCounts = computed(() => campaignStore.sortedUnitCounts);

    const unitCountsFormatted = computed(() => {
      return unitCounts.value.map((unitCount) => {
        return {
          ...unitCount,
          date: dates.convertDatetimeToISO(dates.addUserTimezone(unitCount.date))
        };
      });
    })

    const sortOptions = computed(() => campaignStore.filterOptions.unitCountSorting);
    const sortBy = computed({
      get() {
        return campaignStore.filters.unitCounts.sortBy;
      },
      set(newValue) {
        campaignStore.setUnitCountsSortBy(newValue);
      }
    });

    function openCreateUnitCountModal() {
      this.$refs.campaignUnitCountModal.open({campaign_id: campaignStore.activeCampaign.id});
    }

    function openEditUnitCountModal(cost) {
      this.$refs.campaignUnitCountModal.open(cost)
    }

    function formatDate(timestamp) {
      return dates.formatAsDate(timestamp);
    }

    function truncateDescription(description) {
      return utils.truncateString(description, 100)
    }

    return {
      loading,
      sortOptions,
      sortBy,
      unitCounts,
      unitCountsFormatted,
      openCreateUnitCountModal,
      openEditUnitCountModal,
      formatDate,
      truncateDescription,
    };
  },
};
</script>
